//Assets
import { useEffect, useState } from 'react';
// import { AiOutlineEyeInvisible, AiOutlineEye } from 'react-icons/ai';
import { TextInputSkeleton } from './text-input-skeleton.component';
// import { HiMiniCalendarDays } from 'react-icons/hi2';
import { ITextInput } from './interfaces';
import styles from './text-input.module.css';
const TextInput = (props: ITextInput) => {
	const {
		ariaLabel,
		autoFocus,
		className,
		icon,
		id,
		isRequired,
		label,
		maxLength,
		minLength,
		name,
		onChange,
		onClick,
		onKeyPress,
		pattern,
		placeholder,
		readOnly,
		type = 'text',
		value,
		rows,
		iconPosition = 'start',
		disabled = false,
		spinner = false,
		isLoading = false,
		customHeightSkeleton = '',
		mainPage = false,
		onBlur,
		hideCharCount,
		showCharCount,
	} = props;
	const [showPassword, setShowPassword] = useState(false);
	const [loader, setLoader] = useState(mainPage);
	const [textLength, setTextLength] = useState(0);

	const handleClickShowPassword = () => setShowPassword(!showPassword);
	const handleMouseDownPassword = () => setShowPassword(!showPassword);

	const handleInputChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
		if (onChange) {
			onChange(event);
		}
	};

	const estileIcon = icon && iconPosition === 'start' ? 'pl-8' : 'pr-8';
	const inputClass = `${
		className && className
	} p-2 px-3 mt-2 block resize-none ${estileIcon}  w-full rounded-md text-sm text-custom-main focus:outline-hidden shadow-input-default focus:shadow-input bg-[#FFFFFF]`;

	useEffect(() => {
		setTextLength(value.length);
	}, [value]);

	useEffect(() => {
		if (mainPage) {
			const timeoutId = setTimeout(() => {
				setLoader(false);
			}, 500);

			return () => clearTimeout(timeoutId);
		}
	}, []);

	if (isLoading || loader) {
		return <TextInputSkeleton customHeight={customHeightSkeleton} />;
	}

	return (
		<div className={styles.textContainer}>
			{(label || isRequired) && (
				<label
					htmlFor={id}
					className="text-custom-main block pb-3 text-base font-normal"
				>
					{label}
					{isRequired && (
						<span className="text-custom-dark pl-1 text-xl">*</span>
					)}
				</label>
			)}
			<div className="relative" data-testid="password">
				{/* {type === 'password' && (
					<div
						className="absolute top-1/2 right-2 -translate-y-1/2 transform"
						onClick={handleClickShowPassword}
						onMouseDown={handleMouseDownPassword}
						data-testid="icon-password"
					>
						{!showPassword ? (
							<AiOutlineEyeInvisible className="text-2xl text-black" />
						) : (
							<AiOutlineEye className="text-2xl text-black" />
						)}
					</div>
				)} */}
				{type === 'date' && (
					<div
						className="absolute top-1/2 right-2 -translate-y-1/2 transform"
						onClick={handleClickShowPassword}
						onMouseDown={handleMouseDownPassword}
						data-testid="icon-password"
					>
						{/* <HiMiniCalendarDays className="text-custom-dark text-2xl" />
						 */}
						`{'>'}`
					</div>
				)}
				{type === 'textarea' ? (
					<div className="relative box-border">
						<textarea
							id={id}
							className={`pt-3 pb-9 ${inputClass}`}
							placeholder={placeholder}
							required
							name={name}
							onChange={handleInputChange}
							value={value}
							aria-label={ariaLabel}
							maxLength={maxLength || 200}
							minLength={minLength}
							readOnly={readOnly}
							autoFocus={autoFocus}
							style={{ outline: 'none' }}
							onKeyDown={onKeyPress}
							rows={rows}
							disabled={disabled}
						/>
						{!hideCharCount && (
							<div className="absolute right-0 pt-1 text-right text-sm text-gray-400">
								{textLength} de {maxLength || 200}
							</div>
						)}
					</div>
				) : (
					<>
						<input
							type={
								type === 'password'
									? showPassword
										? 'text'
										: 'password'
									: type === 'date'
									? 'text'
									: type
							}
							id={id}
							className={styles.input}
							placeholder={placeholder}
							required
							name={name}
							onChange={onChange}
							value={value}
							aria-label={ariaLabel}
							pattern={pattern}
							maxLength={maxLength || 100}
							minLength={minLength}
							readOnly={readOnly}
							autoFocus={autoFocus}
							style={{ outline: 'none' }}
							onKeyDown={onKeyPress}
							disabled={disabled}
							onBlur={onBlur}
						/>
						{showCharCount && (
							<div className="absolute right-0 pt-1 text-right text-sm text-gray-400">
								{textLength} de {maxLength || 200}
							</div>
						)}
					</>
				)}
				{icon && iconPosition === 'start' && type !== 'password' && (
					<div
						className={`absolute top-1/2 left-2 -translate-y-1/2 transform ${
							onClick ? 'cursor-pointer' : ''
						}`}
						onClick={onClick}
					>
						{icon}
					</div>
				)}
				{icon && iconPosition === 'end' && type !== 'password' && (
					<div
						className={`absolute top-1/2 right-2 -translate-y-1/2 transform ${
							onClick ? 'cursor-pointer' : ''
						}`}
						onClick={onClick}
					>
						{icon}
					</div>
				)}

				{spinner && (
					<div
						className={`absolute top-1/2 right-2 -translate-y-1/2 transform ${
							onClick ? 'cursor-pointer' : ''
						}`}
						onClick={onClick}
					>
						<div className="flex items-center justify-center">
							<div className="spinner border-custom-light h-5 w-5 animate-spin rounded-full border-t-4"></div>
						</div>
					</div>
				)}
			</div>
			{props.error && (
				<div
					className={`${
						(type !== 'textarea' && showCharCount) ||
						(type === 'textarea' && !hideCharCount)
							? 'pr-20'
							: ''
					}`}
				>
					<span id={`error-msg-${name}`} className={'text-error-main text-xs'}>
						{props.error}
					</span>
				</div>
			)}
		</div>
	);
};

export default TextInput;
